/* Keep Shopify Forms in charge of opening, closing and subscription state. */
(() => {
  const hostId = 'app-embed-container-564720';
  const styleId = 'reise-coupon-teaser-style';
  const styles = `
    :host([data-reise-coupon-teaser]) {
      position: relative;
      z-index: 98;
    }

    #app-embed[data-current-step="tease"] {
      --app-embed-padding-x: 48px;
      --app-embed-padding-y: var(--reise-coupon-offset, 0px);
      --app-embed-width: auto;
    }

    #app-embed[data-current-step="tease"] > [data-testid="app-router"] {
      animation: none;
      rotate: none;
      transform: none;
    }

    #app-embed [data-testid="form-teaser"] {
      position: relative;
      display: grid;
      place-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 80px;
      min-height: 52px;
      max-width: none;
      margin: 0;
      padding: 8px 10px;
      gap: 0;
      border: 0;
      border-radius: 3px;
      background: #000;
      color: #fff;
      box-shadow: 0 1px 4px rgb(0 0 0 / 18%);
      cursor: pointer;
    }

    #app-embed [data-testid="form-teaser"] > h3 {
      margin: 0;
      color: #fff;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: 0;
      text-align: center;
      white-space: pre-line;
    }

    #app-embed [data-testid="form-teaser"] > [role="button"] {
      position: absolute;
      top: -28px;
      right: -28px;
      display: grid;
      place-items: center;
      box-sizing: border-box;
      width: 44px;
      height: 44px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: #fff;
      cursor: pointer;
    }

    #app-embed [data-testid="form-teaser"] > [role="button"]::before {
      position: absolute;
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      border: 1px solid #fff;
      border-radius: 50%;
      background: #000;
      content: '';
    }

    #app-embed [data-testid="form-teaser"] > [role="button"] svg {
      position: relative;
      width: 10px;
      height: 10px;
      color: #fff;
      fill: currentColor;
      fill-opacity: 1;
    }

    #app-embed [data-testid="form-teaser"]:focus-visible,
    #app-embed [data-testid="form-teaser"] > [role="button"]:focus-visible {
      outline: 2px solid #fff;
      outline-offset: 2px;
      box-shadow: 0 0 0 4px #000;
    }

    @media (max-width: 767px) {
      #app-embed[data-current-step="tease"] {
        --app-embed-padding-x: 0px;
        --app-embed-padding-y: 0px;
      }

      #app-embed [data-testid="form-teaser"] {
        position: fixed;
        top: 50%;
        left: env(safe-area-inset-left, 0px);
        width: 124px;
        min-height: 44px;
        padding: 10px 12px;
        transform-origin: top left;
        transform: rotate(-90deg) translateX(-50%);
      }

      #app-embed [data-testid="form-teaser"] > h3 {
        white-space: normal;
      }

      #app-embed [data-testid="form-teaser"] > [role="button"] {
        top: auto;
        right: -22px;
        bottom: -22px;
      }

      #app-embed [data-testid="form-teaser"]:focus-visible {
        outline-offset: -4px;
        box-shadow: none;
      }
    }
  `;

  function connect(host) {
    const shadow = host.shadowRoot;
    if (!shadow || shadow.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = styles.replaceAll('#app-embed', ':host([data-reise-coupon-teaser]) #app-embed');
    shadow.append(style);

    const bottomBars = [...document.querySelectorAll('[data-rp-dock], .productView-stickyCart, .halo-sticky-toolbar-mobile')];
    let showing = false;
    let frame = 0;

    function updateOffset() {
      frame = 0;
      if (!showing) return;
      let offset = 0;
      for (const bar of bottomBars) {
        const rect = bar.getBoundingClientRect();
        const css = getComputedStyle(bar);
        if (rect.height > 0 && rect.bottom >= innerHeight - 1 && rect.top < innerHeight && css.position === 'fixed' && css.visibility !== 'hidden') {
          offset = Math.max(offset, innerHeight - rect.top);
        }
      }
      host.style.setProperty('--reise-coupon-offset', `${Math.ceil(offset)}px`);
    }

    function scheduleOffset() {
      if (showing && !frame) frame = requestAnimationFrame(updateOffset);
    }

    function sync() {
      const teaser = shadow.querySelector('#app-embed[data-current-step="tease"] [data-testid="form-teaser"]');
      const heading = teaser?.querySelector('h3');
      const close = teaser?.querySelector('[role="button"]');
      const nextShowing = Boolean(teaser && heading && close);
      if (nextShowing !== showing) {
        showing = nextShowing;
        host.toggleAttribute('data-reise-coupon-teaser', showing);
        if (showing) window.addEventListener('scroll', scheduleOffset, { passive: true });
        else window.removeEventListener('scroll', scheduleOffset);
      }
      if (!showing) return;
      if (heading.textContent !== 'Cupom\n10% OFF') heading.textContent = 'Cupom\n10% OFF';
      if (teaser.getAttribute('aria-label') !== 'Abrir formulário de cupom de 10% OFF') {
        teaser.setAttribute('aria-label', 'Abrir formulário de cupom de 10% OFF');
      }
      close.setAttribute('aria-label', 'Ocultar cupom');
      scheduleOffset();
    }

    new MutationObserver(sync).observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step'] });
    if ('ResizeObserver' in window) {
      const resize = new ResizeObserver(scheduleOffset);
      bottomBars.forEach(bar => resize.observe(bar));
    }
    window.addEventListener('resize', scheduleOffset, { passive: true });
    sync();
  }

  function findHost() {
    const host = document.getElementById(hostId);
    if (!host) return false;
    customElements.whenDefined('shopify-forms-embed').then(() => connect(host));
    return true;
  }

  if (!findHost()) {
    const observer = new MutationObserver(() => {
      if (findHost()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
  }
})();
